// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom'; 
// import {Grid, Table} from 'lucide-react';
// import CoordinatorHandler from './CoordinatorHandler';
// import useChatNotifications from "../../chat/useChatNotifications";



// const CoordinatorFilters = ({
//   darkMode,
//   filters,
//   handleFilterChange,
//   searchTerm,
//   setSearchTerm,
//   bodyParts,
//   getUniqueOptions,
//   viewMode,
//   setViewMode,
//   showInstitutionDropdown,
//   setShowInstitutionDropdown,
//   institutions,
//   radiologists,
//   patients,
//   faqs: faqsProp,
//   setFaqs: setFaqsProp,
// }) => {
//   const [showDatePicker, setShowDatePicker] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const navigator = useNavigate();
//   // Internal FAQ state (used only when parent doesn't provide faqs)
//   const [internalFaqs, setInternalFaqs] = React.useState([]);
//   const faqs = typeof faqsProp !== 'undefined' ? faqsProp : internalFaqs;
//   const setFaqs = typeof setFaqsProp !== 'undefined' ? setFaqsProp : setInternalFaqs;
//   const [showFaqs, setShowFaqs] = React.useState(false);
//   const [showFilters, setShowFilters] = useState(false);
//   const { unreadCount, resetUnread } = useChatNotifications();
//   const user = JSON.parse(localStorage.getItem("user"))?.user;
//   const isCorporate = user?.group === "corporatecoordinator";
//   React.useEffect(() => {
//     // If parent provided faqs, don't fetch here.
//     if (typeof faqsProp !== 'undefined') return;

//     const fetchFaqs = async () => {
//       try {
//         console.log('CoordinatorHandler import (raw):', CoordinatorHandler);
//         const handler = CoordinatorHandler && CoordinatorHandler.default ? CoordinatorHandler.default : CoordinatorHandler;
//         const response = await handler.getFaqs('coordinator');
//         console.log('Fetched FAQs:', response);
//         if (response && response.success && response.data) {
//           setFaqs(response.data.faqs || response.data || []);
//         } else if (response && Array.isArray(response.faqs)) {
//           setFaqs(response.faqs);
//         }
//       } catch (err) {
//         console.error('Failed to fetch FAQs in CoordinatorFilters:', err);
//       }
//     };
//     fetchFaqs();
//   }, [faqsProp]);

//   return (
//         <div className={`sticky z-40 p-2 rounded-xl shadow-lg border mb-6 backdrop-blur-sm ${
//       darkMode 
//         ? 'bg-gray-800/95 border-gray-700' 
//         : 'bg-white/95 border-gray-100'
//     }`}
//     style={{ top: '80px' }}>
//       {/* Search Input */}
//       <div className="mb-2">
//         <div className="relative">
//           <input
//             type="text"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             placeholder="Search patient, ID, or institution..."
//             className={`w-full px-4 py-3 pl-12 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm ${
//               darkMode 
//                 ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
//                 : 'bg-white border-gray-300'
//             }`}
//           />
//           <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
//             <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//             </svg>
//           </div>
//           {searchTerm && (
//             <button
//               onClick={() => setSearchTerm('')}
//               className="absolute inset-y-0 right-0 pr-4 flex items-center"
//             >
//               <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           )}
//         </div>
//       </div>

      

//       {/* Filter Dropdowns */}
// <div className="flex flex-wrap items-center justify-between gap-3">
//   {/* LEFT SIDE — Filter Button, Date, Clear All */}
//   <div className="flex flex-wrap items-center gap-3">
    
//     {/* Filter Button with Dropdown */}
//     <div className="relative">
//       <button
//         onClick={() => setShowFilters(!showFilters)}
//         className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
//           Object.values(filters).some(f => f) // Check if any filter is active
//             ? 'bg-blue-500 text-white shadow-md'
//             : darkMode 
//               ? 'bg-gray-600 text-gray-300 hover:bg-gray-500' 
//               : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//         }`}
//       >
//         <span>🔍</span>
//         <span className="text-xs">Filters</span>
//         {Object.values(filters).some(f => f) && (
//           <span className="ml-1 px-2 py-1 bg-white/20 text-white rounded-full text-xs">
//             {Object.values(filters).filter(f => f).length}
//           </span>
//         )}
//         <svg 
//           className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`}
//           fill="none" 
//           stroke="currentColor" 
//           viewBox="0 0 24 24"
//         >
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//         </svg>
//       </button>
      
//       {/* Dropdown Menu */}
//       {showFilters && (
//         <div className={`absolute top-full left-0 mt-2 z-50 p-4 rounded-lg shadow-xl border min-w-[600px] ${
//           darkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'
//         }`}>
//           <div className="grid grid-cols-2 gap-3">
//             {/* Body Parts */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Body Parts</label>
//               <select
//                 value={filters.bodyPart}
//                 onChange={(e) => handleFilterChange('bodyPart', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Body Parts</option>
//                 {bodyParts.map(part => (
//                   <option key={part.name} value={part.name}>{part.name}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Allocation Status */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Allocation Status</label>
//               <select
//                 value={filters.allocated}
//                 onChange={(e) => handleFilterChange('allocated', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Allocation Status</option>
//                 <option value="Assigned">Assigned</option>
//                 <option value="Unassigned">Unassigned</option>
//               </select>
//             </div>

//             {/* Status */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Status</label>
//               <select
//                 value={filters.status}
//                 onChange={(e) => handleFilterChange('status', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Status</option>
//                 <option value="Pending">Pending</option>
//                 <option value="Completed">Completed</option>
//               </select>
//             </div>

//             {/* Modality */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Modalities</label>
//               <select
//                 value={filters.modality}
//                 onChange={(e) => handleFilterChange('modality', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Modalities</option>
//                 {getUniqueOptions('modality').map(opt => (
//                   <option key={opt} value={opt}>{opt}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Institution */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Institution</label>
//               <select
//                 value={filters.institution}
//                 onChange={(e) => handleFilterChange('institution', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Institutions</option>
//                 {institutions.map((x) => (
//                   <option key={x} value={x}>{x}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Radiologist */}
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>Radiologist</label>
//               <select
//                 value={filters.radiologist}
//                 onChange={(e) => handleFilterChange('radiologist', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Radiologists</option>
//                 {radiologists.map(rad => (
//                   <option key={rad.id} value={rad.id}>
//                     {rad.first_name} {rad.last_name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Corporate Coordinator */}
//           {!isCorporate && (
//             <div>
//               <label className={`block text-xs font-semibold mb-1 ${
//                 darkMode ? 'text-gray-300' : 'text-gray-700'
//               }`}>
//                 Corporate
//               </label>
          
//               <select
//                 value={filters.corporate}
//                 onChange={(e) => handleFilterChange('corporate', e.target.value)}
//                 className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
//                   darkMode 
//                     ? 'bg-gray-600 border-gray-500 text-white' 
//                     : 'bg-white border-gray-300'
//                 }`}
//               >
//                 <option value="">All Corporate</option>
          
//                 {[...new Set(
//                   (patients || []).flatMap(p => p.corporatecoordinator || [])
//                 )].map((corp, i) => (
//                   <option key={i} value={corp}>{corp}</option>
//                 ))}
//               </select>
//             </div>
//           )}


          
//           {/* Apply/Close Buttons */}
//           <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-300 dark:border-gray-600">
//             <button
//               onClick={() => setShowFilters(false)}
//               className="px-4 py-1.5 bg-blue-500 text-white rounded-lg text-xs font-medium hover:bg-blue-600"
//             >
//               Apply Filters
//             </button>
//           </div>
//         </div>
//       )}
//     </div>


    
//      <div className="relative">
//       <button
//         onClick={() => setShowDatePicker(!showDatePicker)}
//         className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
//           filters.studyDate
//             ? 'bg-blue-500 text-white shadow-md'
//             : darkMode 
//               ? 'bg-gray-600 text-gray-300 hover:bg-gray-500' 
//               : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//         }`}
//       >
//         <span>📅</span>
//         <span className="text-xs">
//           {filters.studyDate ? filters.studyDate : ""}
//         </span>
//       </button>
      
//       {showDatePicker && (
//         <div className={`absolute top-full left-0 mt-2 z-50 p-3 rounded-lg shadow-xl border ${
//           darkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'
//         }`} style={{ minWidth: '260px' }}>
//           <div className="space-y-2">
//             <label className="text-xs text-gray-500">Start date</label>
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//                 darkMode 
//                   ? 'bg-gray-600 border-gray-500 text-white' 
//                   : 'border-gray-300'
//               }`}
//             />

//             <label className="text-xs text-gray-500">End date</label>
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
//                 darkMode 
//                   ? 'bg-gray-600 border-gray-500 text-white' 
//                   : 'border-gray-300'
//               }`}
//             />

//             <div className="flex gap-2">
//               <button
//                 onClick={async () => {
//                   // Validate dates
//                   if (!startDate || !endDate) {
//                     // Mark studyDate in parent for UX feedback
//                     handleFilterChange('studyDate', '');
//                     setShowDatePicker(false);
//                     return;
//                   }

//                   try {
//                     // call API to fetch patients in range
//                     const response = await CoordinatorHandler.getPatientsByDate(startDate, endDate);
//                     // Forward results to parent via a filter key so parent can handle them
//                     handleFilterChange('patientsByDateResults', response);
//                     // Also set readable studyDate filter so UI shows the chosen range
//                     handleFilterChange('studyDate', `${startDate} to ${endDate}`);
//                   } catch (err) {
//                     console.error('Failed to fetch patients by date range:', err);
//                     // still set the visible range
//                     handleFilterChange('studyDate', `${startDate} to ${endDate}`);
//                   } finally {
//                     setShowDatePicker(false);
//                   }
//                 }}
//                 className="flex-1 px-3 py-2 bg-blue-500 text-white rounded-lg text-sm"
//               >
//                 Apply Range
//               </button>

//               <button
//                 onClick={() => {
//                   setStartDate('');
//                   setEndDate('');
//                   handleFilterChange('studyDate', '');
//                   handleFilterChange('patientsByDateResults', null);
//                   setShowDatePicker(false);
//                 }}
//                 className="flex-1 px-3 py-2 bg-red-500 text-white rounded-lg text-sm"
//               >
//                 Clear
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//     <button
//       onClick={() => {
//         handleFilterChange('bodyPart', '');
//         handleFilterChange('allocated', '');
//         handleFilterChange('clinicalHistory', '');
//         handleFilterChange('status', '');
//         handleFilterChange('modality', '');
//         handleFilterChange('institution', '');
//         handleFilterChange('studyDate', '');
//         handleFilterChange('radiologist', '');
//         setSearchTerm('');
//       }}
//       className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg font-medium transition-all duration-200 hover:from-gray-700 hover:to-gray-800 transform hover:scale-105 shadow-lg text-sm"
//     >
      
//       Clear All
//     </button>

    

    
//   </div>


  

//   {/* RIGHT SIDE — Table/Grid Toggle + Calendar */}
//   <div className="flex items-center gap-2">
//     {/* View Toggle */}

//     <button
//         onClick={() => navigator('/xrai-allocation')}
//         className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//           darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
//         }`}
//       >
//         Report 
//       </button>
//     <button
//         onClick={() => navigator('/doctor-status')}
//         className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//           darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
//         }`}
//       >
//         🩺 Doctor Status
//       </button>
    
//     <div className={`flex rounded-lg p-1 ${
//       darkMode ? 'bg-gray-600' : 'bg-gray-100'
//     }`}>
//       <button
//         onClick={() => setViewMode('table')}
//         className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//           viewMode === 'table'
//             ? 'bg-blue-500 text-white shadow-md'
//             : darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
//         }`}
//       >
//         📊 Table
//       </button>
//       <button
//         onClick={() => setViewMode('grid')}
//         className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
//           viewMode === 'grid'
//             ? 'bg-blue-500 text-white shadow-md'
//             : darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
//         }`}
//       >
//         🔳 Grid
//       </button>

//     </div>


//     {/* FAQ Button */}
//     <div className="relative">
//         {/* FAQ Section - Compact Button */}
//         <div className="relative flex items-center gap-2">
  
//   {/* FAQ Button */}
//   <button 
//     onClick={() => setShowFaqs(!showFaqs)}
//     aria-label={`FAQ (${faqs.length})`}
//     className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-200 shadow-md"
//   >
//     <svg 
//       className="w-5 h-5" 
//       fill="none" 
//       stroke="currentColor" 
//       viewBox="0 0 24 24"
//     >
//       <path 
//         strokeLinecap="round" 
//         strokeLinejoin="round" 
//         strokeWidth={2} 
//         d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
//       />
//     </svg>
//     <span className="hidden md:inline font-semibold">FAQ</span>
//   </button>

//   {/* Chat Button */}
//   {/* Chat Button (hidden for corporate coordinators) */}
//   {!isCorporate && (
//     <button
//       onClick={() => {
//         resetUnread();
//         window.open("/coordinator/live-chat", "_blank");
//       }}
//       className="relative flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-md"
//     >
//       <span className="hidden md:inline font-semibold">Chat</span>
  
//       {unreadCount > 0 && (
//         <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full animate-pulse">
//           {unreadCount}
//         </span>
//       )}
//     </button>
//   )}



// </div>

//         {/* FAQ Modal/Overlay */}
//         {showFaqs && (
//           <div 
//             className="fixed inset-0 bg-opacity-50 z-50 flex items-center justify-center p-4"
//             onClick={() => setShowFaqs(false)}
//           >
//             <div 
//               className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col"
//               onClick={(e) => e.stopPropagation()}
//             >
//               {/* Header */}
//               <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4 flex items-center justify-between rounded-t-xl">
//                 <div className="flex items-center gap-3">
//                   <svg 
//                     className="w-6 h-6 text-white" 
//                     fill="none" 
//                     stroke="currentColor" 
//                     viewBox="0 0 24 24"
//                   >
//                     <path 
//                       strokeLinecap="round" 
//                       strokeLinejoin="round" 
//                       strokeWidth={2} 
//                       d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
//                     />
//                   </svg>
//                   <h2 className="text-white font-bold text-xl">Help & Support</h2>
//                 </div>
//                 <button
//                   onClick={() => setShowFaqs(false)}
//                   className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
//                 >
//                   <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>
            
//               {/* Scrollable Content */}
//               <div className="flex-1 overflow-y-auto p-6" style={{ scrollbarWidth: 'thin' }}>
//                 {faqs.length > 0 ? (
//                   <div className="space-y-4">
//                     {faqs.map((faq, index) => (
//                       <div 
//                         key={faq.id} 
//                         className="bg-gradient-to-r from-blue-50 to-white border-l-4 border-blue-500 rounded-lg p-4 hover:shadow-md transition-shadow"
//                       >
//                         <div className="flex gap-4">
//                           <div className="flex-shrink-0">
//                             <div className="w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
//                               Q{index + 1}
//                             </div>
//                           </div>
//                           <div className="flex-1">
//                             <h3 className="font-bold text-gray-900 mb-2 text-lg">
//                               {faq.question}
//                             </h3>
//                             <p className="text-gray-700 leading-relaxed">
//                               {faq.answer}
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="text-center py-12">
//                     <svg 
//                       className="w-20 h-20 mx-auto text-gray-300 mb-4" 
//                       fill="none" 
//                       stroke="currentColor" 
//                       viewBox="0 0 24 24"
//                     >
//                       <path 
//                         strokeLinecap="round" 
//                         strokeLinejoin="round" 
//                         strokeWidth={2} 
//                         d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
//                       />
//                     </svg>
//                     <p className="text-gray-500 font-semibold text-lg">No FAQs available</p>
//                     <p className="text-gray-400 text-sm mt-2">Check back later for helpful information</p>
//                   </div>
//                 )}
//               </div>
            
//               {/* Footer */}
//               <div className="border-t px-6 py-4 bg-gray-50 rounded-b-xl">
//                 <button
//                   onClick={() => setShowFaqs(false)}
//                   className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Add this CSS for better scrollbar styling */}
//         <style jsx>{`
//           div[style*="scrollbarWidth"] {
//             scrollbar-color: #3b82f6 #e5e7eb;
//           }
        
//           div[style*="scrollbarWidth"]::-webkit-scrollbar {
//             width: 8px;
//           }
        
//           div[style*="scrollbarWidth"]::-webkit-scrollbar-track {
//             background: #f3f4f6;
//             border-radius: 10px;
//           }
        
//           div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb {
//             background: #3b82f6;
//             border-radius: 10px;
//           }
        
//           div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb:hover {
//             background: #2563eb;
//           }
//         `}</style>
//     </div>
//   </div>
// </div>

//     </div>
//   );
// };

// export default CoordinatorFilters;





import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import {Grid, Table} from 'lucide-react';
import CoordinatorHandler from './CoordinatorHandler';
import useChatNotifications from "../../chat/useChatNotifications";



const CoordinatorFilters = ({
  darkMode,
  filters,
  handleFilterChange,
  searchTerm,
  setSearchTerm,
  bodyParts,
  getUniqueOptions,
  viewMode,
  setViewMode,
  showInstitutionDropdown,
  setShowInstitutionDropdown,
  institutions,
  radiologists,
  patients,
  faqs: faqsProp,
  setFaqs: setFaqsProp,
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const navigator = useNavigate();
  // Internal FAQ state (used only when parent doesn't provide faqs)
  const [internalFaqs, setInternalFaqs] = React.useState([]);
  const faqs = typeof faqsProp !== 'undefined' ? faqsProp : internalFaqs;
  const setFaqs = typeof setFaqsProp !== 'undefined' ? setFaqsProp : setInternalFaqs;
  const [showFaqs, setShowFaqs] = React.useState(false);
  const [showFilters, setShowFilters] = useState(false);
  // 1. Local state to hold selections before applying
  const [localFilters, setLocalFilters] = React.useState(filters);

  // 2. Keep local filters synced if filters are cleared from the outside
  React.useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  // 3. Helper to update the temporary local state
  const handleLocalFilterChange = (key, value) => {
    setLocalFilters((prev) => ({ ...prev, [key]: value }));
  };

  // 4. Push all local selections to the backend ONLY when Apply is clicked
  const handleApplyFilters = () => {
    Object.keys(localFilters).forEach((key) => {
      if (localFilters[key] !== filters[key]) {
        handleFilterChange(key, localFilters[key]);
      }
    });
    setShowFilters(false); // Close the menu
  };
  const { unreadCount, resetUnread } = useChatNotifications();
  const user = JSON.parse(localStorage.getItem("user"))?.user;
  const isCorporate = user?.group === "corporatecoordinator";
  React.useEffect(() => {
    // If parent provided faqs, don't fetch here.
    if (typeof faqsProp !== 'undefined') return;

    const fetchFaqs = async () => {
      try {
        console.log('CoordinatorHandler import (raw):', CoordinatorHandler);
        const handler = CoordinatorHandler && CoordinatorHandler.default ? CoordinatorHandler.default : CoordinatorHandler;
        const response = await handler.getFaqs('coordinator');
        console.log('Fetched FAQs:', response);
        if (response && response.success && response.data) {
          setFaqs(response.data.faqs || response.data || []);
        } else if (response && Array.isArray(response.faqs)) {
          setFaqs(response.faqs);
        }
      } catch (err) {
        console.error('Failed to fetch FAQs in CoordinatorFilters:', err);
      }
    };
    fetchFaqs();
  }, [faqsProp]);

  return (
        <div className={`sticky z-40 p-2 rounded-xl shadow-lg border mb-6 backdrop-blur-sm ${
      darkMode 
        ? 'bg-gray-800/95 border-gray-700' 
        : 'bg-white/95 border-gray-100'
    }`}
    style={{ top: '80px' }}>
      {/* Search Input */}
      <div className="mb-2">
        <div className="relative">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search patient, ID, or institution..."
            className={`w-full px-4 py-3 pl-12 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm ${
              darkMode 
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                : 'bg-white border-gray-300'
            }`}
          />
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          {searchTerm && (
            <button
              onClick={() => setSearchTerm('')}
              className="absolute inset-y-0 right-0 pr-4 flex items-center"
            >
              <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>

      

      {/* Filter Dropdowns */}
<div className="flex flex-wrap items-center justify-between gap-3">
  {/* LEFT SIDE — Filter Button, Date, Clear All */}
  <div className="flex flex-wrap items-center gap-3">
    
    {/* Filter Button with Dropdown */}
    <div className="relative">
      <button
        onClick={() => setShowFilters(!showFilters)}
        className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
          Object.values(filters).some(f => f) // Check if any filter is active
            ? 'bg-blue-500 text-white shadow-md'
            : darkMode 
              ? 'bg-gray-600 text-gray-300 hover:bg-gray-500' 
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <span>🔍</span>
        <span className="text-xs">Filters</span>
        {Object.values(filters).some(f => f) && (
          <span className="ml-1 px-2 py-1 bg-white/20 text-white rounded-full text-xs">
            {Object.values(filters).filter(f => f).length}
          </span>
        )}
        <svg 
          className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`}
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {/* Dropdown Menu */}
      {showFilters && (
        <div className={`absolute top-full left-0 mt-2 z-50 p-4 rounded-lg shadow-xl border min-w-[600px] ${
          darkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'
        }`}>
          <div className="grid grid-cols-2 gap-3">
            {/* Body Parts */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Body Parts</label>
              <select
                value={localFilters.bodyPart}
                onChange={(e) => handleLocalFilterChange('bodyPart', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Body Parts</option>
                {bodyParts.map(part => (
                  <option key={part.name} value={part.name}>{part.name}</option>
                ))}
              </select>
            </div>

            {/* Allocation Status */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Allocation Status</label>
              <select
                value={localFilters.allocated}
                onChange={(e) => handleLocalFilterChange('allocated', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Allocation Status</option>
                <option value="Assigned">Assigned</option>
                <option value="Unassigned">Unassigned</option>
              </select>
            </div>

            {/* Status */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Status</label>
              <select
                value={localFilters.status}
                onChange={(e) => handleLocalFilterChange('status', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Status</option>
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
              </select>
            </div>

            {/* Modality */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Modalities</label>
              <select
                value={localFilters.modality}
                onChange={(e) => handleLocalFilterChange('modality', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Modalities</option>
                {/* 🆕 Fixed Modalities array so they don't disappear */}
                {['CR', 'CT', 'MR', 'DX', 'XRAY', 'PR', 'SR'].map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>

            {/* Institution */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Institution</label>
              <select
                value={localFilters.institution}
                onChange={(e) => handleLocalFilterChange('institution', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Institutions</option>
                {institutions.map((x) => (
                  <option key={x} value={x}>{x}</option>
                ))}
              </select>
            </div>

            {/* Radiologist */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Radiologist</label>
              <select
                value={localFilters.radiologist}
                onChange={(e) => handleLocalFilterChange('radiologist', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Radiologists</option>
                {radiologists.map(rad => (
                  <option key={rad.id} value={rad.id}>
                    {rad.first_name} {rad.last_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Clinical History */}
            <div>
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Clinical History
              </label>
              <select
                value={localFilters.clinicalHistory}
                onChange={(e) => handleLocalFilterChange('clinicalHistory', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All History Status</option>
                <option value="Available">Available</option>
                <option value="Not Available">Not Available</option>
              </select>
            </div>

          {/* Corporate Coordinator */}
          {!isCorporate && (
            <div className="mt-3">
              <label className={`block text-xs font-semibold mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Corporate
              </label>
              <select
                value={localFilters.corporate}
                onChange={(e) => handleLocalFilterChange('corporate', e.target.value)}
                className={`w-full px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs ${
                  darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'bg-white border-gray-300'
                }`}
              >
                <option value="">All Corporate</option>
                {[...new Set(
                  (patients || []).flatMap(p => p.corporatecoordinator || [])
                )].map((corp, i) => (
                  <option key={i} value={corp}>{corp}</option>
                ))}
              </select>
            </div>
          )}

          {/* Apply/Close Buttons */}
          <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-300 dark:border-gray-600">
            <button
              onClick={handleApplyFilters} // 🆕 This triggers the final apply
              className="px-6 py-2 bg-blue-600 text-white rounded-lg text-xs font-bold hover:bg-blue-700 shadow-md transition-all"
            >
              Apply Filters
            </button>
          </div>
        </div>
      )}
    </div>


    
     <div className="relative">
      <button
        onClick={() => setShowDatePicker(!showDatePicker)}
        className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
          filters.studyDate
            ? 'bg-blue-500 text-white shadow-md'
            : darkMode 
              ? 'bg-gray-600 text-gray-300 hover:bg-gray-500' 
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <span>📅</span>
        <span className="text-xs">
          {filters.studyDate ? filters.studyDate : ""}
        </span>
      </button>
      
      {showDatePicker && (
        <div className={`absolute top-full left-0 mt-2 z-50 p-3 rounded-lg shadow-xl border ${
          darkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-200'
        }`} style={{ minWidth: '260px' }}>
          <div className="space-y-2">
            <label className="text-xs text-gray-500">Start date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                darkMode 
                  ? 'bg-gray-600 border-gray-500 text-white' 
                  : 'border-gray-300'
              }`}
            />

            <label className="text-xs text-gray-500">End date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                darkMode 
                  ? 'bg-gray-600 border-gray-500 text-white' 
                  : 'border-gray-300'
              }`}
            />

            {/* <div className="flex gap-2">
              <button
                onClick={async () => {
                  // Validate dates
                  if (!startDate || !endDate) {
                    // Mark studyDate in parent for UX feedback
                    handleFilterChange('studyDate', '');
                    setShowDatePicker(false);
                    return;
                  }

                  try {
                    // call API to fetch patients in range
                    const response = await CoordinatorHandler.getPatientsByDate(startDate, endDate);
                    // Forward results to parent via a filter key so parent can handle them
                    handleFilterChange('patientsByDateResults', response);
                    // Also set readable studyDate filter so UI shows the chosen range
                    handleFilterChange('studyDate', `${startDate} to ${endDate}`);
                  } catch (err) {
                    console.error('Failed to fetch patients by date range:', err);
                    // still set the visible range
                    handleFilterChange('studyDate', `${startDate} to ${endDate}`);
                  } finally {
                    setShowDatePicker(false);
                  }
                }}
                className="flex-1 px-3 py-2 bg-blue-500 text-white rounded-lg text-sm"
              >
                Apply Range
              </button>

              <button
                onClick={() => {
                  setStartDate('');
                  setEndDate('');
                  handleFilterChange('studyDate', '');
                  handleFilterChange('patientsByDateResults', null);
                  setShowDatePicker(false);
                }}
                className="flex-1 px-3 py-2 bg-red-500 text-white rounded-lg text-sm"
              >
                Clear
              </button>
            </div> */}


            <div className="flex gap-2">
              <button
                onClick={() => {
                  // Validate dates
                  if (!startDate || !endDate) {
                    handleFilterChange('studyDate', '');
                    setShowDatePicker(false);
                    return;
                  }

                  // Simply update the filter state. 
                  // The useEffect in CoordinatorDashboard will detect this and fetch the data!
                  handleFilterChange('studyDate', `${startDate} to ${endDate}`);
                  setShowDatePicker(false);
                }}
                className="flex-1 px-3 py-2 bg-blue-500 text-white rounded-lg text-sm"
              >
                Apply Range
              </button>

              <button
                onClick={() => {
                  setStartDate('');
                  setEndDate('');
                  handleFilterChange('studyDate', '');
                  setShowDatePicker(false);
                }}
                className="flex-1 px-3 py-2 bg-red-500 text-white rounded-lg text-sm"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    <button
      onClick={() => {
        handleFilterChange('bodyPart', '');
        handleFilterChange('allocated', '');
        handleFilterChange('clinicalHistory', '');
        handleFilterChange('status', '');
        handleFilterChange('modality', '');
        handleFilterChange('institution', '');
        handleFilterChange('studyDate', '');
        handleFilterChange('radiologist', '');
        setSearchTerm('');
      }}
      className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg font-medium transition-all duration-200 hover:from-gray-700 hover:to-gray-800 transform hover:scale-105 shadow-lg text-sm"
    >
      
      Clear All
    </button>

    

    
  </div>


  

  {/* RIGHT SIDE — Table/Grid Toggle + Calendar */}
  <div className="flex items-center gap-2">
    {/* View Toggle */}

    <button
        onClick={() => navigator('/xrai-allocation')}
        className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
          darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        Report 
      </button>
    <button
        onClick={() => navigator('/doctor-status')}
        className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
          darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        🩺 Doctor Status
      </button>
    
    <div className={`flex rounded-lg p-1 ${
      darkMode ? 'bg-gray-600' : 'bg-gray-100'
    }`}>
      <button
        onClick={() => setViewMode('table')}
        className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
          viewMode === 'table'
            ? 'bg-blue-500 text-white shadow-md'
            : darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        📊 Table
      </button>
      <button
        onClick={() => setViewMode('grid')}
        className={`px-4 py-2 rounded-md font-medium transition-all duration-200 ${
          viewMode === 'grid'
            ? 'bg-blue-500 text-white shadow-md'
            : darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        🔳 Grid
      </button>

    </div>


    {/* FAQ Button */}
    <div className="relative">
        {/* FAQ Section - Compact Button */}
        <div className="relative flex items-center gap-2">
  
  {/* FAQ Button */}
  <button 
    onClick={() => setShowFaqs(!showFaqs)}
    aria-label={`FAQ (${faqs.length})`}
    className="flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-200 shadow-md"
  >
    <svg 
      className="w-5 h-5" 
      fill="none" 
      stroke="currentColor" 
      viewBox="0 0 24 24"
    >
      <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth={2} 
        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
      />
    </svg>
    <span className="hidden md:inline font-semibold">FAQ</span>
  </button>

  {/* Chat Button */}
  {/* Chat Button (hidden for corporate coordinators) */}
  {!isCorporate && (
    <button
      onClick={() => {
        resetUnread();
        window.open("/coordinator/live-chat", "_blank");
      }}
      className="relative flex items-center gap-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-md"
    >
      <span className="hidden md:inline font-semibold">Chat</span>
  
      {unreadCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full animate-pulse">
          {unreadCount}
        </span>
      )}
    </button>
  )}



</div>

        {/* FAQ Modal/Overlay */}
        {showFaqs && (
          <div 
            className="fixed inset-0 bg-opacity-50 z-50 flex items-center justify-center p-4"
            onClick={() => setShowFaqs(false)}
          >
            <div 
              className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4 flex items-center justify-between rounded-t-xl">
                <div className="flex items-center gap-3">
                  <svg 
                    className="w-6 h-6 text-white" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                    />
                  </svg>
                  <h2 className="text-white font-bold text-xl">Help & Support</h2>
                </div>
                <button
                  onClick={() => setShowFaqs(false)}
                  className="text-white hover:bg-white/20 rounded-full p-2 transition-colors"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            
              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto p-6" style={{ scrollbarWidth: 'thin' }}>
                {faqs.length > 0 ? (
                  <div className="space-y-4">
                    {faqs.map((faq, index) => (
                      <div 
                        key={faq.id} 
                        className="bg-gradient-to-r from-blue-50 to-white border-l-4 border-blue-500 rounded-lg p-4 hover:shadow-md transition-shadow"
                      >
                        <div className="flex gap-4">
                          <div className="flex-shrink-0">
                            <div className="w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold">
                              Q{index + 1}
                            </div>
                          </div>
                          <div className="flex-1">
                            <h3 className="font-bold text-gray-900 mb-2 text-lg">
                              {faq.question}
                            </h3>
                            <p className="text-gray-700 leading-relaxed">
                              {faq.answer}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <svg 
                      className="w-20 h-20 mx-auto text-gray-300 mb-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
                      />
                    </svg>
                    <p className="text-gray-500 font-semibold text-lg">No FAQs available</p>
                    <p className="text-gray-400 text-sm mt-2">Check back later for helpful information</p>
                  </div>
                )}
              </div>
            
              {/* Footer */}
              <div className="border-t px-6 py-4 bg-gray-50 rounded-b-xl">
                <button
                  onClick={() => setShowFaqs(false)}
                  className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add this CSS for better scrollbar styling */}
        <style jsx>{`
          div[style*="scrollbarWidth"] {
            scrollbar-color: #3b82f6 #e5e7eb;
          }
        
          div[style*="scrollbarWidth"]::-webkit-scrollbar {
            width: 8px;
          }
        
          div[style*="scrollbarWidth"]::-webkit-scrollbar-track {
            background: #f3f4f6;
            border-radius: 10px;
          }
        
          div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb {
            background: #3b82f6;
            border-radius: 10px;
          }
        
          div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb:hover {
            background: #2563eb;
          }
        `}</style>
    </div>
  </div>
</div>

    </div>
  );
};

export default CoordinatorFilters;